module.exports = __webpack_public_path__ + "static/media/feedActive.01682f0f.svg";